export default {
    last_interaction_ticket: 'Commented on ticket ',
}
